export const userRegion = document.querySelector<HTMLElement>('html')?.lang ?? undefined;
export const shopCurrency = document.querySelector<HTMLElement>('html')?.dataset.currency ?? 'EUR';

/**
 * Format cents to a money string without currency symbol using the shop currecny code.
 */
export function formatMoneyWithouthCurrency(cents: number): string {
  return (cents / 100)
    .toLocaleString(userRegion, {
      style: 'currency',
      currency: shopCurrency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      currencyDisplay: 'code',
    })
    .replace(shopCurrency, '')
    .replace('.', ',')
    .trim();
}
